import api from 'services/api';
import { selectPreferences } from 'store/Preferences/selectors';
import { selectCsrfToken, selectIsLoggedIn } from 'store/Sesion/selectors';

export const SAVE_PREFERENCES_SUCCESS = 'SAVE_PREFERENCES_SUCCESS';
export const SAVE_PREFERENCES_FAIL = 'SAVE_PREFERENCES_FAIL';

let pendingSave = Promise.resolve();

export function updatePreferences (items) {
  return (dispatch, getState) => {
    const buildItems = typeof items === 'function' ? items : () => items;
    const requestSession = selectCsrfToken(getState());

    pendingSave = pendingSave.then(async () => {
      const state = getState();

      if (!selectIsLoggedIn(state) || selectCsrfToken(state) !== requestSession) return undefined;

      try {
        const preferences = selectPreferences(state);
        const itemsCopy = JSON.parse(JSON.stringify(buildItems(preferences)));
        const newPreferences = { ...preferences, ...itemsCopy };

        await api.preferences.save({ preferences: newPreferences });
        return dispatch({ type: SAVE_PREFERENCES_SUCCESS, preferences: newPreferences });
      } catch (e) {
        return dispatch({ type: SAVE_PREFERENCES_FAIL, data: e.message });
      }
    });

    return pendingSave;
  };
}
